import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708ff8a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-warp" }
const _hoisted_2 = { class: "title-warp" }
const _hoisted_3 = { class: "base-info-warp d-flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex-1f visit" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "card"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head" }, "需求信息卡", -1))
const _hoisted_9 = { class: "card-content" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "需求类别", -1))
const _hoisted_12 = { class: "card-val" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "需求人", -1))
const _hoisted_15 = { class: "card-val" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "联系电话", -1))
const _hoisted_18 = {
  key: 0,
  class: "card-val"
}
const _hoisted_19 = {
  key: 1,
  class: "card-val"
}
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "需求执行地址", -1))
const _hoisted_22 = { class: "card-val" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "需求酬劳", -1))
const _hoisted_25 = { class: "card-val" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "需求状态", -1))
const _hoisted_28 = {
  key: 0,
  class: "card-val"
}
const _hoisted_29 = {
  key: 1,
  class: "card-val"
}
const _hoisted_30 = {
  key: 2,
  class: "card-val"
}
const _hoisted_31 = {
  key: 3,
  class: "card-val"
}
const _hoisted_32 = {
  key: 4,
  class: "card-val"
}
const _hoisted_33 = {
  key: 5,
  class: "card-val"
}
const _hoisted_34 = {
  key: 1,
  class: "card"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head" }, "活动信息卡", -1))
const _hoisted_36 = { class: "card-content" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "活动主持人", -1))
const _hoisted_39 = { class: "card-val" }
const _hoisted_40 = { class: "d-flex" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "活动时间", -1))
const _hoisted_42 = { class: "card-val" }
const _hoisted_43 = { class: "d-flex" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "联系电话", -1))
const _hoisted_45 = {
  key: 0,
  class: "card-val"
}
const _hoisted_46 = {
  key: 1,
  class: "card-val"
}
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "活动地址", -1))
const _hoisted_49 = { class: "card-val" }
const _hoisted_50 = { class: "d-flex" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f card-label" }, "活动状态", -1))
const _hoisted_52 = {
  key: 0,
  class: "card-val"
}
const _hoisted_53 = {
  key: 1,
  class: "card-val"
}
const _hoisted_54 = {
  key: 2,
  class: "card-val"
}
const _hoisted_55 = { class: "comment-warp" }
const _hoisted_56 = { class: "d-flex comment-title-warp" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f comment-title-label" }, "精选留言", -1))
const _hoisted_58 = {
  key: 0,
  class: "empty-message"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无数据", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "d-flex d-flex-h-center comment-item-head-warp" }
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "d-flex-1f comment-head-middle-warp" }
const _hoisted_64 = { class: "comment-username-warp" }
const _hoisted_65 = {
  key: 0,
  class: "enroll-tag"
}
const _hoisted_66 = {
  key: 1,
  class: "enroll-tag"
}
const _hoisted_67 = { class: "comment-date-warp" }
const _hoisted_68 = { class: "comment-time-warp" }
const _hoisted_69 = { class: "comment-content-warp" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 1,
  class: "comment-reply-warp"
}
const _hoisted_72 = { class: "d-flex d-flex-h-center" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "d-flex-1f" }
const _hoisted_75 = { class: "reply-username" }
const _hoisted_76 = { class: "reply-time" }
const _hoisted_77 = { class: "comment-form-warp" }
const _hoisted_78 = { class: "enroll-popup-head-warp" }
const _hoisted_79 = { class: "enroll-form-warp" }
const _hoisted_80 = { class: "enroll-text-input-warp" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "enroll-popup-head-warp" }, "反馈信息", -1))
const _hoisted_82 = { class: "enroll-form-warp" }
const _hoisted_83 = { class: "enroll-text-input-warp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.img(_ctx.data.headUrl)
        }, null, 8, _hoisted_4),
        _createTextVNode(" " + _toDisplayString(_ctx.data.userName) + "/ " + _toDisplayString(_ctx.format(_ctx.data.createTimeStamp, "yyyy-MM-dd HH:mm")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.watchCount) + "人已看", 1)
    ]),
    _createElementVNode("div", {
      innerHTML: _ctx.data.content,
      class: "content"
    }, null, 8, _hoisted_6),
    (_ctx.helpActType == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.data.loveHelpPublishType == 0 ? "个人发布" : _ctx.data.loveHelpPublishType == 1 ? "机构发布" : " "), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.data.contactUser), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              (_ctx.data.hasOwnProperty('helpOrder'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.data.phone), 1))
                : _createCommentVNode("", true),
              (!_ctx.data.hasOwnProperty('helpOrder'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 成功接单后会显示联系电话 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.data.targetAddress), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.data.payPoint) + "积分", 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (_ctx.data.helpStatus == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, "已开始"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "已接单"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, "用户取消"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, "客户取消"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "已完成"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 8)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "未接单"))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 6 && _ctx.data.isMy == true)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 6,
                    round: "",
                    type: "success",
                    size: "mini",
                    color: "#FD5C02",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.freeBack.showPopup = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("我要反馈 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.data.helpStatus == 8 && _ctx.data.isMy == false && !_ctx.data.hasOwnProperty('helpOrder'))
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 7,
                    round: "",
                    type: "success",
                    size: "mini",
                    color: "#FD5C02",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enroll.showPopup = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("马上接单 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.data.neighborActivityStatus == 2 && _ctx.data.hasOwnProperty('helpOrder'))
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 8,
                    disabled: "",
                    round: "",
                    type: "success",
                    size: "mini",
                    color: "#FD5C02",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enroll.showPopup = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("已经接单 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.helpActType == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.data.actHostUser), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.format(_ctx.data.startActTime, "yyyy-MM-dd HH:mm")) + "~" + _toDisplayString(_ctx.format(_ctx.data.endActTime, "yyyy-MM-dd HH:mm")), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              (_ctx.data.isSignUp == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.data.phone), 1))
                : _createCommentVNode("", true),
              (_ctx.data.isSignUp == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 成功报名后会显示联系电话 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.data.province) + _toDisplayString(_ctx.data.city) + _toDisplayString(_ctx.data.district) + _toDisplayString(_ctx.data.address), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              (_ctx.data.neighborActivityStatus == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, "未开始"))
                : _createCommentVNode("", true),
              (_ctx.data.neighborActivityStatus == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, "已开始"))
                : _createCommentVNode("", true),
              (_ctx.data.neighborActivityStatus == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, "已结束"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.data.neighborActivityStatus == 1 && _ctx.data.isMy == false && _ctx.data.isSignUp == false)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    style: {"width":"100%"},
                    round: "",
                    type: "success",
                    size: "mini",
                    color: "#FD5C02",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enroll.showPopup = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("马上报名 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.data.neighborActivityStatus == 1 && _ctx.data.isMy == false && _ctx.data.isSignUp == true)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 1,
                    style: {"width":"100%"},
                    disabled: "",
                    round: "",
                    type: "success",
                    size: "mini",
                    color: "#FD5C02"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("已经报名 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", {
          class: "comment-edit-btn-warp",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showComment(false, '', '')))
        }, [
          _createTextVNode(" 写留言 "),
          _createVNode(_component_van_icon, { name: "records" })
        ])
      ]),
      (_ctx.dataHelpUserMessage.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataHelpUserMessage, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "comment-item-warp"
        }, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "comment-item-img",
                src: _ctx.img(item.headUrl)
              }, null, 8, _hoisted_62)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createTextVNode(_toDisplayString(item.userName) + " ", 1),
                (_ctx.helpActType == 3 && item.isSignUp == false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, "未报名"))
                  : _createCommentVNode("", true),
                (_ctx.helpActType == 3 && item.isSignUp == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, "已报名"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.format(item.messageTime, "yyyy-MM-dd")), 1)
            ]),
            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.format(item.messageTime, "HH:mm")), 1)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createTextVNode(_toDisplayString(item.content) + " ", 1),
            (!item.postReply && _ctx.data.isMy == true)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.showComment(true, item.userName, item.id)),
                  class: "comment-btn"
                }, " | 回复", 8, _hoisted_70))
              : _createCommentVNode("", true),
            (item.postReply)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        class: "reply-img",
                        src: _ctx.img(item.postReply.headUrl)
                      }, null, 8, _hoisted_73)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, _toDisplayString(item.postReply.userName), 1),
                      _createElementVNode("div", _hoisted_76, " 回复于 " + _toDisplayString(_ctx.format(item.postReply.messageTime, "yyyy-MM-dd HH:mm")), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(item.postReply.content), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      (!_ctx.isNoMoreMessage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showMoreMessage())),
            class: "comment-more-warp"
          }, [
            _createTextVNode("查看更多 "),
            _createVNode(_component_van_icon, { name: "play" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.comment.showPopup,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comment.showPopup) = $event)),
      round: "",
      closeable: "",
      "close-icon": "close",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_77, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.comment.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comment.value) = $event)),
            rows: "3",
            autosize: "",
            class: "commment-input",
            type: "textarea",
            maxlength: "100",
            placeholder: _ctx.comment.placeholder,
            "show-word-limit": ""
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_van_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitHelpUserMessage())),
            type: "primary",
            block: "",
            color: "#FD5C02"
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交留言")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.enroll.showPopup,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.enroll.showPopup) = $event)),
      round: "",
      closeable: "",
      "close-icon": "close",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.helpActType == 3 ? "报名信息" : "接单信息"), 1),
        _createElementVNode("div", _hoisted_79, [
          _createVNode(_component_van_cell_group, {
            class: "enroll-cell-group",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: _ctx.enroll.form.userName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.enroll.form.userName) = $event)),
                label: "姓名",
                placeholder: "请输入姓名"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.enroll.form.phone,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.enroll.form.phone) = $event)),
                label: "联系电话",
                placeholder: "请输入联系电话"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, { label: "备注留言" }, {
                input: _withCtx(() => []),
                _: 1
              }),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_van_field, {
                  modelValue: _ctx.enroll.form.memo,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enroll.form.memo) = $event)),
                  rows: "1",
                  class: "enroll-text-input",
                  type: "textarea",
                  maxlength: "100",
                  placeholder: _ctx.enroll.placeholder,
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitActSignUp())),
            type: "primary",
            block: "",
            color: "#FD5C02"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认报名")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.freeBack.showPopup,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.freeBack.showPopup) = $event)),
      round: "",
      closeable: "",
      "close-icon": "close",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _hoisted_81,
        _createElementVNode("div", _hoisted_82, [
          _createVNode(_component_van_cell_group, {
            class: "enroll-cell-group",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, { label: "反馈信息" }, {
                input: _withCtx(() => []),
                _: 1
              }),
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_van_field, {
                  modelValue: _ctx.freeBack.form.feedback,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.freeBack.form.feedback) = $event)),
                  rows: "1",
                  class: "enroll-text-input",
                  type: "textarea",
                  maxlength: "100",
                  placeholder: _ctx.freeBack.placeholder,
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitFreeback())),
            type: "primary",
            block: "",
            color: "#FD5C02"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认反馈")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}